import React, {Component} from 'react';
import axios from 'axios';
import Breadcrumb from  '../../Layout/Breadcrumb';
import { Card, CardBody } from 'reactstrap';
import {FaShoppingCart} from "react-icons/fa";
import { connect } from 'react-redux';
import { Alert } from 'reactstrap';
import { Spinner } from 'react-bootstrap';
import Select from 'react-select';
import CreateOrderVpsComponent from "./creates/CreateOrderVpsComponent";
import CreateOrderHostingComponent from "./creates/CreateOrderHostingComponent";
import CreateOrderAddonComponent from "./creates/CreateOrderAddonComponent";
import CreateOrderUpgradeComponent from "./creates/CreateOrderUpgradeComponent";
import CreateOrderExpireVpsComponent from "./creates/CreateOrderExpireVpsComponent";
import CreateOrderExpireHostingComponent from "./creates/CreateOrderExpireHostingComponent";
import CreateOrderVpsUsComponent from "./creates/CreateOrderVpsUsComponent";
import CreateOrderExpireVpsUsComponent from "./creates/CreateOrderExpireVpsUsComponent";

class CreateOrderComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loadPage: false,
            isLoading: false,
            isLoadingService: false,
            isLoadingDetail: false,
            isLoadingAddon: false,
            isService: false,
            isDetailOrder: false,
            listGroupProduct: [],
            error: false,
            messageError: '',
            btnSubmit: true,
            errorForm: false,
            messageForm: "",
            errorService: false,
            messageService: "",
            errorDetail: false,
            messageDetail: "",
            errorAddon: false,
            messageAddon: "",
            listUser: [],
            listTypeOrder: [],
            listProduct: [],
            listBillingCycle: [],
            listOs: [],
            userId: 0,
            typeOrder: '',
            productId: 0,
            billingCycle: '',
            qtt: 1,
            os: '',
            status: 'Pending',
            minusCredit: false,
            contentDetailOrder: [],
            isAddon: false,
            isFormAddon: false,
            contentAddon: [],
            addonCpu: 0,
            addonRam: 0,
            addonDisk: 0,
            stateUsList: [],
            stateUs: '',
            vpsId: 0,
            hostingId: 0,
            domain: '',
            listHosting: [],
            listProductUpgrade: [],
            productUpgrade: 0
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        this.getConfigCreateOrder();
    }

    getConfigCreateOrder = () => {
        this.setState({
            loadPage: true
        });
        let dataAuth = {
            username: process.env.REACT_APP_CLIENT_ID,
            password: process.env.REACT_APP_CLIENT_PASSWD,
            token: process.env.REACT_APP_KEY,
        };
        axios.get( process.env.REACT_APP_API_URL + '/api/admin/order/getConfigCreateOrder',
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization' : this.props.token,
                    'dataAgency' : JSON.stringify(dataAuth)
                }
            }
        )
            .then( (ref) => {
                // console.log(ref.data);
                if ( ref.data.error === 0 ) {
                    this.setState({
                        listUser: ref.data.listUser,
                        listTypeOrder: ref.data.typeOrder,
                        loadPage: false
                    })
                } else {
                    if ( ref.data.error === 9999 || ref.data.error === 9998 || ref.data.error === 9997 ) {
                        this.props.logOut();
                    } else {
                        this.setState({
                            error: true,
                            messageError: ref.data.message,
                            loadPage: false
                        })
                    }
                }
                // console.log(this.state.perPage);
            })
            .catch( () => {
                // console.log(error);
                this.setState({
                    isLoading: false
                });
                this.setState({
                    error: true,
                    messageError: 'Lấy dữ liệu sản phẩm thất bại',
                })
            })
    }

    changeUser = async selectedOption => {
        let choosseUser = selectedOption.value;
        await this.setState({
            userId: choosseUser,
            isFormAddon: false,
            qtt: 1,
            contentDetailOrder: [],
        })
        await this.loadConfigOrder();
    }

    changeType = async selectedOption => {
        let choosse = selectedOption.value;
        await this.setState({
            typeOrder: choosse,
            isFormAddon: false,
            qtt: 1,
            contentDetailOrder: [],
        })
        await this.loadConfigOrder();
    }

    loadConfigOrder = () => {
        if ( this.state.userId && this.state.typeOrder.length ) {
            this.setState({
                isLoadingService: true,
                isService: true,
                btnSubmit: true,
            });
            let dataAuth = {
                username: process.env.REACT_APP_CLIENT_ID,
                password: process.env.REACT_APP_CLIENT_PASSWD,
                token: process.env.REACT_APP_KEY,
            };
            let data = 'userId=' + this.state.userId + '&typeOrder=' + this.state.typeOrder;
            // console.log(data);
            axios.get( process.env.REACT_APP_API_URL + '/api/admin/order/getConfigService?' + data,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization' : this.props.token,
                        'dataAgency' : JSON.stringify(dataAuth)
                    }
                }
            )
                .then( (ref) => {
                    // console.log(ref.data);
                    if ( ref.data.error === 0 ) {
                        if ( this.state.typeOrder === 'addon_vps' || this.state.typeOrder === 'addon_cloud_server'
                            || this.state.typeOrder === 'expire_vps' || this.state.typeOrder === 'expire_cloud_server'
                            || this.state.typeOrder === 'expire_vps_us' ) {
                            this.setState({
                                listVps: ref.data.listVps,
                                isLoadingService: false,
                                btnSubmit: false,
                            })
                        }
                        else if ( this.state.typeOrder === 'upgrade' || this.state.typeOrder === 'expire_hosting_cpanel' ) {
                            this.setState({
                                listHosting: ref.data.listHosting,
                                isLoadingService: false,
                                btnSubmit: false,
                            })
                        }
                        else if (  this.state.typeOrder === 'order_vps_us' ) {
                            this.setState({
                                listProduct: ref.data.listProduct,
                                stateUsList: ref.data.stateUsList,
                                listBillingCycle: ref.data.listBillingCycle,
                                isLoadingService: false,
                                btnSubmit: false,
                                listOs: [],
                            })
                        }
                        else {
                            this.setState({
                                listProduct: ref.data.listProduct,
                                listBillingCycle: ref.data.listBillingCycle,
                                isLoadingService: false,
                                btnSubmit: false,
                                listOs: [],
                            })
                        }
                    } else {
                        if ( ref.data.error === 9999 || ref.data.error === 9998 || ref.data.error === 9997 ) {
                            this.props.logOut();
                        } else {
                            this.setState({
                                errorService: true,
                                messageService: ref.data.message,
                                isLoadingService: false,
                                btnSubmit: false,
                            })
                        }
                    }
                    // console.log(this.state.perPage);
                })
                .catch( () => {
                    this.setState({
                        isLoading: false
                    });
                    this.setState({
                        errorService: true,
                        messageService: 'Lấy dữ liệu sản phẩm / dịch vụ thất bại',
                    })
                })
        }
    }

    loadService = () => {
        if ( this.state.isLoadingService ) {
            return (
                <div className="text-center">
                    <Spinner animation="grow" variant="primary" />
                    <Spinner animation="grow" variant="secondary" />
                    <Spinner animation="grow" variant="success" />
                    <Spinner animation="grow" variant="danger" />
                    <Spinner animation="grow" variant="warning" />
                    <Spinner animation="grow" variant="info" />
                </div>
            )
        }
        else {
            if ( this.state.typeOrder === 'order_vps' || this.state.typeOrder === 'order_nat_vps' || this.state.typeOrder === 'order_cloud_server' ) {
                return (
                    <CreateOrderVpsComponent
                        listProduct={ this.state.listProduct }
                        listBillingCycle={this.state.listBillingCycle}
                        listOs={ this.state.listOs }
                        os={ this.state.os }
                        qtt={ this.state.qtt }
                        productId={ this.state.productId }
                        billingCycle={ this.state.billingCycle }
                        status={ this.state.status }
                        minusCredit={ this.state.minusCredit }
                        isAddon={ this.state.isAddon }
                        isFormAddon={ this.state.isFormAddon }
                        isLoadingAddon={ this.state.isLoadingAddon }
                        errorAddon={ this.state.errorAddon }
                        messageAddon={ this.state.messageAddon }
                        productAddonCpu={ this.state.productAddonCpu }
                        productAddonRam={ this.state.productAddonRam }
                        productAddonDisk={ this.state.productAddonDisk }
                        choosseProduct={ () => this.choosseProduct }
                        choosseBillingCycle={ () => this.choosseBillingCycle }
                        changeQtt={ (value) => this.changeQtt(value) }
                        changeInput={ (name, value) => this.changeInput(name, value) }
                        btnAddon={ () => this.btnAddon() }
                        changeAddonCpu={ (number) => this.changeAddonCpu(number) }
                        changeAddonRam={ (number) => this.changeAddonRam(number) }
                        changeAddonDisk={ (number) => this.changeAddonDisk(number) }
                    />
                )
            }
            else if (this.state.typeOrder === 'order_vps_us') {
                return (
                    <CreateOrderVpsUsComponent
                        listProduct={ this.state.listProduct }
                        listBillingCycle={this.state.listBillingCycle}
                        listOs={ this.state.listOs }
                        stateUsList={ this.state.stateUsList }
                        stateUs={ this.state.stateUs }
                        os={ this.state.os }
                        qtt={ this.state.qtt }
                        productId={ this.state.productId }
                        billingCycle={ this.state.billingCycle }
                        status={ this.state.status }
                        minusCredit={ this.state.minusCredit }
                        choosseProduct={ () => this.choosseProduct }
                        choosseBillingCycle={ () => this.choosseBillingCycle }
                        changeQtt={ (value) => this.changeQtt(value) }
                        changeInput={ (name, value) => this.changeInput(name, value) }
                    />
                )
            }
            else if ( this.state.typeOrder === 'order_hosting_cpanel' ) {
                return (
                    <CreateOrderHostingComponent
                        listProduct={ this.state.listProduct }
                        listBillingCycle={this.state.listBillingCycle}
                        productId={ this.state.productId }
                        billingCycle={ this.state.billingCycle }
                        status={ this.state.status }
                        domain={ this.state.domain }
                        minusCredit={ this.state.minusCredit }
                        choosseProduct={ () => this.choosseProduct }
                        choosseBillingCycle={ () => this.choosseBillingCycle }
                        changeInput={ (name, value) => this.changeInput(name, value) }
                    />
                )
            }
            else if ( this.state.typeOrder === 'addon_vps' || this.state.typeOrder === 'addon_cloud_server' ) {
                return (
                    <CreateOrderAddonComponent
                        listVps={ this.state.listVps }
                        minusCredit={ this.state.minusCredit }
                        isAddon={ this.state.isAddon }
                        status={ this.state.status }
                        isFormAddon={ this.state.isFormAddon }
                        isLoadingAddon={ this.state.isLoadingAddon }
                        errorAddon={ this.state.errorAddon }
                        messageAddon={ this.state.messageAddon }
                        productAddonCpu={ this.state.productAddonCpu }
                        productAddonRam={ this.state.productAddonRam }
                        productAddonDisk={ this.state.productAddonDisk }
                        choosseVps={ () => this.choosseVps }
                        changeAddonCpu={ (number) => this.changeAddonCpu(number) }
                        changeAddonRam={ (number) => this.changeAddonRam(number) }
                        changeAddonDisk={ (number) => this.changeAddonDisk(number) }
                    />
                )
            }
            else if ( this.state.typeOrder === 'upgrade' ) {
                return (
                    <CreateOrderUpgradeComponent
                        listHosting={ this.state.listHosting }
                        minusCredit={ this.state.minusCredit }
                        isAddon={ this.state.isAddon }
                        status={ this.state.status }
                        isFormAddon={ this.state.isFormAddon }
                        isLoadingAddon={ this.state.isLoadingAddon }
                        listProductUpgrade={ this.state.listProductUpgrade }
                        choosseHosting={ () => this.choosseHosting }
                        choosseProductUpgrade={ () => this.choosseProductUpgrade }
                    />
                )
            }
            else if ( this.state.typeOrder === 'expire_vps' || this.state.typeOrder === 'expire_cloud_server' ) {
                return (
                    <CreateOrderExpireVpsComponent
                        listVps={ this.state.listVps }
                        minusCredit={ this.state.minusCredit }
                        listBillingCycle={this.state.listBillingCycle}
                        status={ this.state.status }
                        isFormAddon={ this.state.isFormAddon }
                        isLoadingAddon={ this.state.isLoadingAddon }
                        errorAddon={ this.state.errorAddon }
                        messageAddon={ this.state.messageAddon }
                        choosseVps={ () => this.choosseVpsExpire }
                        choosseBillingCycle={ () => this.choosseBillingCycle }
                    />
                )
            }
            else if ( this.state.typeOrder === 'expire_vps_us' ) {
                return (
                    <CreateOrderExpireVpsUsComponent
                        listVps={ this.state.listVps }
                        minusCredit={ this.state.minusCredit }
                        listBillingCycle={this.state.listBillingCycle}
                        status={ this.state.status }
                        isFormAddon={ this.state.isFormAddon }
                        isLoadingAddon={ this.state.isLoadingAddon }
                        errorAddon={ this.state.errorAddon }
                        messageAddon={ this.state.messageAddon }
                        choosseVps={ () => this.choosseVpsExpire }
                        choosseBillingCycle={ () => this.choosseBillingCycle }
                    />
                )
            }
            else if ( this.state.typeOrder === 'expire_hosting_cpanel' ) {
                return (
                    <CreateOrderExpireHostingComponent
                        listHosting={ this.state.listHosting }
                        minusCredit={ this.state.minusCredit }
                        listBillingCycle={this.state.listBillingCycle}
                        status={ this.state.status }
                        isFormAddon={ this.state.isFormAddon }
                        isLoadingAddon={ this.state.isLoadingAddon }
                        errorAddon={ this.state.errorAddon }
                        messageAddon={ this.state.messageAddon }
                        choosseHosting={ () => this.choosseHostingExpire }
                        choosseBillingCycle={ () => this.choosseBillingCycle }
                    />
                )
            }
        }
    }

    choosseProduct = async selectedOption => {
        // console.log("da den ")
        let choosse = selectedOption.value;
        let isAddon = true;
        this.state.listProduct.forEach( (product) => {
            if ( product.id === parseInt(choosse) ) {
                isAddon = product.isAddon;
            }
        })
        await this.setState({
            productId: choosse,
            isAddon: isAddon,
            isFormAddon: false
        })
        await this.loadDetailOrder();
        if ( this.state.typeOrder === 'order_vps' || this.state.typeOrder === 'order_nat_vps'
            || this.state.typeOrder === 'order_cloud_server' || this.state.typeOrder === 'order_vps_us'
        ) {
            this.loadOsVps();
            this.loadBillingCycle();
        }
        else if ( this.state.typeOrder === 'order_hosting_cpanel' ) {
            this.loadBillingCycle();
        }
    }

    choosseProductUpgrade = async selectedOption => {
        let choosse = selectedOption.value;
        await this.setState({
            productUpgrade: choosse,
        })
        await this.loadDetailOrder();
    }

    loadOsVps = () => {
        let dataAuth = {
            username: process.env.REACT_APP_CLIENT_ID,
            password: process.env.REACT_APP_CLIENT_PASSWD,
            token: process.env.REACT_APP_KEY,
        };
        let data = 'userId=' + this.state.userId + "&productId=" + this.state.productId ;
        // console.log(data)
        axios.get( process.env.REACT_APP_API_URL + '/api/admin/order/loadOsVps?' + data,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization' : this.props.token,
                    'dataAgency' : JSON.stringify(dataAuth)
                }
            }
        )
            .then( (ref) => {
                // console.log(ref.data);
                if ( ref.data.error === 0 ) {
                    this.setState({
                        listOs: ref.data.content,
                    })
                } else {
                    if ( ref.data.error === 9999 || ref.data.error === 9998 || ref.data.error === 9997 ) {
                        this.props.logOut();
                    }
                }
                // console.log(this.state.perPage);
            })
            .catch( () => {
            })
    }

    loadBillingCycle = () => {
        let dataAuth = {
            username: process.env.REACT_APP_CLIENT_ID,
            password: process.env.REACT_APP_CLIENT_PASSWD,
            token: process.env.REACT_APP_KEY,
        };
        let data = 'userId=' + this.state.userId + "&productId=" + this.state.productId ;
        // console.log(data)
        axios.get( process.env.REACT_APP_API_URL + '/api/admin/order/loadBillingCycle?' + data,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization' : this.props.token,
                    'dataAgency' : JSON.stringify(dataAuth)
                }
            }
        )
            .then( (ref) => {
                // console.log(ref.data);
                if ( ref.data.error === 0 ) {
                    this.setState({
                        listBillingCycle: ref.data.content,
                    })
                } else {
                    if ( ref.data.error === 9999 || ref.data.error === 9998 || ref.data.error === 9997 ) {
                        this.props.logOut();
                    }
                }
                // console.log(this.state.perPage);
            })
            .catch( () => {
            })
    }

    choosseBillingCycle = async selectedOption => {
        let choosse = selectedOption.value;
        await this.setState({
            billingCycle: choosse
        })
        await this.loadDetailOrder();
    }

    choosseVps = async selectedOption => {
        let choosse = selectedOption.value;
        let productId = 0;
        this.state.listVps.forEach( (vps) => {
            if ( vps.value === parseInt(choosse) ) {
                productId = vps.product_id;
            }
        })
        await this.setState({
            vpsId: choosse,
            productId: productId,
            isFormAddon: false
        })
        await this.btnAddon();
        await this.loadDetailOrder();
    }

    choosseHostingExpire = async selectedOption => {
        let choosse = selectedOption.value;
        let productId = 0;
        this.state.listHosting.forEach( (hosting) => {
            if ( hosting.value === parseInt(choosse) ) {
                productId = hosting.product_id;
            }
        })
        await this.setState({
            hostingId: choosse,
            productId: productId,
            isFormAddon: false
        })
        await this.loadBillingCycle();
        await this.loadDetailOrder();
    }

    choosseVpsExpire = async selectedOption => {
        let choosse = selectedOption.value;
        let productId = 0;
        this.state.listVps.forEach( (vps) => {
            if ( vps.value === parseInt(choosse) ) {
                productId = vps.product_id;
            }
        })
        await this.setState({
            vpsId: choosse,
            productId: productId,
            isFormAddon: false
        })
        await this.loadBillingCycle();
        await this.loadDetailOrder();
    }

    choosseHosting = async selectedOption => {
        let choosse = selectedOption.value;
        await this.setState({
            hostingId: choosse,
            isFormAddon: false
        })
        await this.loadProductUpgrade();
        await this.loadDetailOrder();
    }

    changeQtt = async (value) => {
        await this.setState({
            qtt: value
        })
        await this.loadDetailOrder();
    }

    changeInput = (name, value) => {
        this.setState({
            [name]: value
        });
    }

    changeStatus = (event) => {
        let name = event.target.name;
        let value = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
        this.setState({
            [name]: value
        });
    }

    loadDetailOrder = () => {
        // console.log("da den 3");
        // console.log(this.state.typeOrder)
        if ( this.state.typeOrder === 'addon_vps' || this.state.typeOrder === 'addon_cloud_server'
            || this.state.typeOrder === 'expire_vps' || this.state.typeOrder === 'expire_cloud_server'
            || this.state.typeOrder === 'expire_vps_us' ) {
            // console.log("da den 2");
            if ( this.state.vpsId > 0 ) {
                this.setState({
                    isLoadingDetail: true,
                });
                let dataAuth = {
                    username: process.env.REACT_APP_CLIENT_ID,
                    password: process.env.REACT_APP_CLIENT_PASSWD,
                    token: process.env.REACT_APP_KEY,
                };
                let data = 'userId=' + this.state.userId + '&billingCycle=' + this.state.billingCycle + "&productId="
                    + this.state.productId + "&qtt=" + this.state.qtt + '&typeOrder=' + this.state.typeOrder
                    + '&addonCpu=' + this.state.addonCpu + '&addonRam=' + this.state.addonRam + '&addonDisk=' + this.state.addonDisk
                    + '&vpsId=' + this.state.vpsId;
                // console.log(data)
                axios.get( process.env.REACT_APP_API_URL + '/api/admin/order/loadDetailOrder?' + data,
                    {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization' : this.props.token,
                            'dataAgency' : JSON.stringify(dataAuth)
                        }
                    }
                )
                    .then( (ref) => {
                        // console.log(ref.data);
                        if ( ref.data.error === 0 ) {
                            this.setState({
                                isDetailOrder: true,
                                isFormAddon: true,
                                contentDetailOrder: ref.data.content,
                                isLoadingDetail: false,
                            })
                        } else {
                            if ( ref.data.error === 9999 || ref.data.error === 9998 || ref.data.error === 9997 ) {
                                this.props.logOut();
                            } else {
                                this.setState({
                                    isDetailOrder: true,
                                    errorDetail: true,
                                    messageDetail: ref.data.message,
                                    vpsId: 0,
                                    addonCpu: 0,
                                    addonDisk: 0,
                                    addonRam: 0,
                                    isLoadingDetail: false,
                                })
                            }
                        }
                        // console.log(this.state.perPage);
                    })
                    .catch( () => {
                        this.setState({
                            isDetailOrder: true,
                            errorDetail: true,
                            isLoadingDetail: false,
                            messageDetail: 'Lấy dữ liệu sản phẩm / dịch vụ thất bại',
                        })
                    })
            }
        }
        else if ( this.state.typeOrder === 'upgrade' || this.state.typeOrder === 'expire_hosting_cpanel' ) {
            if ( this.state.hostingId > 0 ) {
                this.setState({
                    isLoadingDetail: true,
                });
                let dataAuth = {
                    username: process.env.REACT_APP_CLIENT_ID,
                    password: process.env.REACT_APP_CLIENT_PASSWD,
                    token: process.env.REACT_APP_KEY,
                };
                let data = 'userId=' + this.state.userId + '&billingCycle=' + this.state.billingCycle + "&productId="
                    + this.state.productId + "&qtt=" + this.state.qtt + '&typeOrder=' + this.state.typeOrder
                    + '&addonCpu=' + this.state.addonCpu + '&addonRam=' + this.state.addonRam + '&addonDisk=' + this.state.addonDisk
                    + '&hostingId=' + this.state.hostingId + '&productUpgrade=' + this.state.productUpgrade;
                axios.get( process.env.REACT_APP_API_URL + '/api/admin/order/loadDetailOrder?' + data,
                    {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization' : this.props.token,
                            'dataAgency' : JSON.stringify(dataAuth)
                        }
                    }
                )
                    .then( (ref) => {
                        console.log(ref.data);
                        if ( ref.data.error === 0 ) {
                            this.setState({
                                isDetailOrder: true,
                                isFormAddon: true,
                                contentDetailOrder: ref.data.content,
                                isLoadingDetail: false,
                            })
                        } else {
                            if ( ref.data.error === 9999 || ref.data.error === 9998 || ref.data.error === 9997 ) {
                                this.props.logOut();
                            } else {
                                this.setState({
                                    isDetailOrder: true,
                                    errorDetail: true,
                                    messageDetail: ref.data.message,
                                    isLoadingDetail: false,
                                    hostingId: 0,
                                    productUpgrade: 0
                                })
                            }
                        }
                        // console.log(this.state.perPage);
                    })
                    .catch( () => {
                        this.setState({
                            isDetailOrder: true,
                            errorDetail: true,
                            isLoadingDetail: false,
                            messageDetail: 'Lấy dữ liệu sản phẩm / dịch vụ thất bại',
                        })
                    })
            }
        }
        else {
            // console.log("da den 2");
            if ( this.state.productId && this.state.qtt > 0 && this.state.billingCycle) {
                // console.log("da den 1");
                this.setState({
                    isLoadingDetail: true,
                });
                let dataAuth = {
                    username: process.env.REACT_APP_CLIENT_ID,
                    password: process.env.REACT_APP_CLIENT_PASSWD,
                    token: process.env.REACT_APP_KEY,
                };
                let data = 'userId=' + this.state.userId + '&billingCycle=' + this.state.billingCycle + "&productId="
                    + this.state.productId + "&qtt=" + this.state.qtt + '&typeOrder=' + this.state.typeOrder
                    + '&addonCpu=' + this.state.addonCpu + '&addonRam=' + this.state.addonRam + '&addonDisk=' + this.state.addonDisk
                    + '&vpsId=' + this.state.vpsId;
                // console.log(data)
                axios.get( process.env.REACT_APP_API_URL + '/api/admin/order/loadDetailOrder?' + data,
                    {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization' : this.props.token,
                            'dataAgency' : JSON.stringify(dataAuth)
                        }
                    }
                )
                    .then( (ref) => {
                        // console.log(ref.data);
                        this.setState({
                            isLoadingDetail: false,
                        });
                        if ( ref.data.error === 0 ) {
                            this.setState({
                                isDetailOrder: true,
                                contentDetailOrder: ref.data.content,
                                isLoadingDetail: false,
                            })
                        } else {
                            if ( ref.data.error === 9999 || ref.data.error === 9998 || ref.data.error === 9997 ) {
                                this.props.logOut();
                            } else {
                                this.setState({
                                    isDetailOrder: true,
                                    errorDetail: true,
                                    messageDetail: ref.data.message,
                                    isLoadingDetail: false,
                                    addonCpu: 0,
                                    addonDisk: 0,
                                    addonRam: 0,
                                    productId: 0
                                })
                            }
                        }
                        // console.log(this.state.perPage);
                    })
                    .catch( () => {
                        this.setState({
                            isDetailOrder: true,
                            errorDetail: true,
                            isLoadingDetail: false,
                            messageDetail: 'Lấy dữ liệu sản phẩm / dịch vụ thất bại',
                        })
                    })
            }
        }
    }

    btnAddon = () => {
        // console.log("da den")
        this.setState({
            isLoadingAddon: true,
            isAddon: false
        });
        let dataAuth = {
            username: process.env.REACT_APP_CLIENT_ID,
            password: process.env.REACT_APP_CLIENT_PASSWD,
            token: process.env.REACT_APP_KEY,
        };
        let data = 'userId=' + this.state.userId + "&productId="
            + this.state.productId + '&typeOrder=' + this.state.typeOrder;
        // console.log(data)
        axios.get( process.env.REACT_APP_API_URL + '/api/admin/order/loadAddonVps?' + data,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization' : this.props.token,
                    'dataAgency' : JSON.stringify(dataAuth)
                }
            }
        )
            .then( (ref) => {
                // console.log(ref.data);
                this.setState({
                    isLoadingAddon: false,
                });
                if ( ref.data.error === 0 ) {
                    this.setState({
                        productAddonCpu: ref.data.addonCpu,
                        productAddonRam: ref.data.addonRam,
                        productAddonDisk: ref.data.addonDisk,
                        isFormAddon: true
                    })
                } else {
                    if ( ref.data.error === 9999 || ref.data.error === 9998 || ref.data.error === 9997 ) {
                        this.props.logOut();
                    } else {
                        this.setState({
                            errorAddon: true,
                            messageAddon: ref.data.message,
                            isFormAddon: false
                        })
                    }
                }
                // console.log(this.state.perPage);
            })
            .catch( () => {
                this.setState({
                    errorAddon: true,
                    isLoadingAddon: false,
                    messageAddon: 'Lấy dữ liệu Addon thất bại',
                    isFormAddon: false
                })
            })
    }

    loadProductUpgrade = () => {
        this.setState({
            isLoadingAddon: true,
            isAddon: false
        });
        let dataAuth = {
            username: process.env.REACT_APP_CLIENT_ID,
            password: process.env.REACT_APP_CLIENT_PASSWD,
            token: process.env.REACT_APP_KEY,
        };
        let data = 'userId=' + this.state.userId + "&hostingId="
            + this.state.hostingId + '&typeOrder=' + this.state.typeOrder;
        axios.get( process.env.REACT_APP_API_URL + '/api/admin/order/loadProductUpgrade?' + data,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization' : this.props.token,
                    'dataAgency' : JSON.stringify(dataAuth)
                }
            }
        )
            .then( (ref) => {
                // console.log("upgrade ", ref.data);
                if ( ref.data.error === 0 ) {
                    this.setState({
                        listProductUpgrade: ref.data.content,
                        isFormAddon: true,
                        isLoadingAddon: false,
                    })
                } else {
                    if ( ref.data.error === 9999 || ref.data.error === 9998 || ref.data.error === 9997 ) {
                        this.props.logOut();
                    } else {
                        this.setState({
                            errorAddon: true,
                            messageAddon: ref.data.message,
                            isFormAddon: false,
                            isLoadingAddon: false,
                        })
                    }
                }
                // console.log(this.state.perPage);
            })
            .catch( () => {
                this.setState({
                    errorAddon: true,
                    isLoadingAddon: false,
                    messageAddon: 'Lấy dữ liệu nâng cấp hosting thất bại',
                    isFormAddon: false
                })
            })
    }

    changeAddonCpu = async (number) => {
        // console.log(number)
        await this.setState({
            addonCpu: number
        })
        await this.loadDetailOrder();
    }

    changeAddonRam = async (number) => {
        // console.log(number)
        await this.setState({
            addonRam: number
        })
        await this.loadDetailOrder();
    }

    changeAddonDisk = async (number) => {
        // console.log(number)
        await this.setState({
            addonDisk: number
        })
        await this.loadDetailOrder();
    }

    submit = () => {
        if ( this.validate() ) {
            this.setState({
                loadPage: true,
                btnSubmit: true,
            });
            let dataAuth = {
                username: process.env.REACT_APP_CLIENT_ID,
                password: process.env.REACT_APP_CLIENT_PASSWD,
                token: process.env.REACT_APP_KEY,
            };
            // form
            let form = {
                userId: this.state.userId,
                typeOrder: this.state.typeOrder,
                productId: this.state.productId,
                status: this.state.status,
                billingCycle: this.state.billingCycle,
                qtt: this.state.qtt,
                os: this.state.os,
                addonCpu: this.state.addonCpu,
                addonRam: this.state.addonRam,
                addonDisk: this.state.addonDisk,
                minusCredit: this.state.minusCredit,
                domain: this.state.domain,
                vpsId: this.state.vpsId,
                hostingId: this.state.hostingId,
                productUpgrade: this.state.productUpgrade,
                state: this.state.stateUs
            }
            // console.log(form);
            // request
            axios.post( process.env.REACT_APP_API_URL + '/api/admin/order/createOrder', form,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization' : this.props.token,
                        'dataAgency' : JSON.stringify(dataAuth)
                    }
                }
            )
                .then( (ref) => {
                    // console.log(ref.data);
                    this.setState({
                        loadPage: false,
                        btnSubmit: false,
                    });
                    if ( ref.data.error === 0 ) {
                        this.redirect();
                    } else {
                        if ( ref.data.error === 9999 || ref.data.error === 9998 || ref.data.error === 9997 ) {
                            this.props.logOut();
                        } else {
                            this.setState({
                                errorForm: true,
                                isService: false,
                                messageForm: ref.data.message,
                            })
                        }
                    }
                    // console.log(this.state.perPage);
                })
                .catch( () => {
                    this.setState({
                        errorForm: true,
                        btnSubmit: false,
                        isService: false,
                        messageForm: 'Tạo đơn đặt hàng thất bại',
                    })
                })
        }
    }

    validate = () => {
        if ( this.state.typeOrder === 'order_vps' || this.state.typeOrder === 'order_nat_vps' || this.state.typeOrder === 'order_cloud_server' ) {
            if ( this.state.productId === 0 ) {
                this.setState({
                    errorForm: true,
                    messageForm: 'Sản phẩm không được để trống'
                })
                return false;
            }
            else if ( this.state.billingCycle === '' ) {
                this.setState({
                    errorForm: true,
                    messageForm: 'Thời gian thuê không được để trống'
                })
                return false;
            }
            else if ( this.state.os === '' ) {
                this.setState({
                    errorForm: true,
                    messageForm: 'Hệ điều hành không được để trống'
                })
                return false;
            }
            else if ( this.state.qtt < 1 ) {
                this.setState({
                    errorForm: true,
                    messageForm: 'Số lượng không được nhỏ hơn 1'
                })
                return false;
            }
        }
        else if ( this.state.typeOrder === 'order_vps_us' ) {
            if ( this.state.productId === 0 ) {
                this.setState({
                    errorForm: true,
                    messageForm: 'Sản phẩm không được để trống'
                })
                return false;
            }
            else if ( this.state.billingCycle === '' ) {
                this.setState({
                    errorForm: true,
                    messageForm: 'Thời gian thuê không được để trống'
                })
                return false;
            }
            else if ( this.state.qtt < 1 ) {
                this.setState({
                    errorForm: true,
                    messageForm: 'Số lượng không được nhỏ hơn 1'
                })
                return false;
            }
            else if (this.state.stateUs === '') {
                this.setState({
                    errorForm: true,
                    messageForm: 'Vui lòng chọn state (Bang Us)'
                });
                return false;
            }
        }
        else if ( this.state.typeOrder === 'expire_vps' || this.state.typeOrder === 'expire_cloud_server'
            || this.state.typeOrder === 'expire_vps_us' ) {
            if ( this.state.vpsId === 0 ) {
                this.setState({
                    errorForm: true,
                    messageForm: 'VPS không được để trống'
                })
                return false;
            }
            else if ( this.state.billingCycle === '' ) {
                this.setState({
                    errorForm: true,
                    messageForm: 'Thời gian thuê không được để trống'
                })
                return false;
            }
        }
        else if ( this.state.typeOrder === 'order_hosting_cpanel' ) {
            if ( this.state.productId === 0 ) {
                this.setState({
                    errorForm: true,
                    messageForm: 'Sản phẩm không được để trống'
                })
                return false;
            }
            else if ( this.state.billingCycle === '' ) {
                this.setState({
                    errorForm: true,
                    messageForm: 'Thời gian thuê không được để trống'
                })
                return false;
            }
            else if ( this.state.domain === '' ) {
                this.setState({
                    errorForm: true,
                    messageForm: 'Domain không được để trống'
                })
                return false;
            }
        }
        else if ( this.state.typeOrder === 'addon_vps' || this.state.typeOrder === 'addon_cloud_server' ) {
            if ( this.state.vpsId === 0 ) {
                this.setState({
                    errorForm: true,
                    messageForm: 'VPS không được để trống'
                })
                return false;
            }
            else if ( !this.state.addonCpu && !this.state.addonRam && !this.state.addonDisk ) {
                this.setState({
                    errorForm: true,
                    messageForm: 'Addon CPU và Addon RAM và Addon DISK không được để trống'
                })
                return false;
            }

        }
        else if ( this.state.typeOrder === 'upgrade' ) {
            if ( this.state.hostingId === 0 ) {
                this.setState({
                    errorForm: true,
                    messageForm: 'Hosting không được để trống'
                })
                return false;
            }
            else if ( !this.state.productUpgrade ) {
                this.setState({
                    errorForm: true,
                    messageForm: 'Gói nâng cấp không được để trống'
                })
                return false;
            }

        }
        return true;
    }

    redirect = () => {
        this.props.notification({
            isNotification: true,
            textNotification: 'Tạo đơn đặt hàng thành công'
        });
        this.props.shouldRedirect();
    }

    render() {
        return (
            <>
                {
                    this.state.loadPage ? (
                        <div className="cr-page-spinner load-page">
                            <Spinner animation="border" variant="primary" />
                        </div>
                    ) : (
                        <>
                            <Breadcrumb title={"Tạo đơn đặt hàng"} page={"Đơn đặt hàng"} icon={<FaShoppingCart className="breadcrumb-icon"/>}/>
                            {
                                this.state.error ? (
                                    <Alert color="danger">
                                        <div className='text-center'>
                                            { this.state.messageError }
                                        </div>
                                    </Alert>
                                ) : (
                                    <>
                                        {
                                            this.state.errorForm ? (
                                                <Alert color="danger">
                                                    { this.state.messageForm }
                                                </Alert>
                                            ) : (
                                                <></>
                                            )
                                        }
                                        <Card>
                                            <CardBody>
                                                <div className="row">
                                                    <div className="col-md-8">
                                                        <div className="create_order">
                                                            <div className="row form-group mt-4">
                                                                <div className="col-md-3 text-right font-weight-bold">Tên khách hàng</div>
                                                                <div className="col-md-8">
                                                                    <Select
                                                                        options={this.state.listUser}
                                                                        onChange={this.changeUser}
                                                                        className="basic-single"
                                                                        classNamePrefix="select"
                                                                        placeholder={'Chọn khách hàng'}
                                                                        defaultValue={ this.state.userId }
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="row form-group mt-4">
                                                                <div className="col-md-3 text-right font-weight-bold">Trạng thái</div>
                                                                <div className="col-md-8">
                                                                    <select className="form-control" name="status" onChange={ this.changeStatus } value={ this.state.status }>
                                                                        <option value="Pending">Chưa thanh toán</option>
                                                                        <option value="Finish">Đã thanh toán</option>
                                                                    </select>
                                                                </div>
                                                            </div>
                                                            <div className="row form-group mt-4">
                                                                <div className="col-md-3 text-right font-weight-bold">Đơn hàng</div>
                                                                <div className="col-md-8">
                                                                    <Select
                                                                        options={this.state.listTypeOrder}
                                                                        onChange={this.changeType}
                                                                        className="basic-single"
                                                                        classNamePrefix="select"
                                                                        placeholder={'Chọn loại đơn đặt hàng'}
                                                                        defaultValue={ this.state.typeOrder }
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        {
                                                            this.state.isService ? (
                                                                <>
                                                                    <h3>Sản phẩm / Dịch vụ</h3>
                                                                    <div className="create_order">
                                                                        { this.loadService() }
                                                                    </div>
                                                                </>
                                                            ) : (
                                                                <></>
                                                            )
                                                        }
                                                    </div>
                                                    <div className="col-md-4">
                                                        <div className="detail-order">
                                                            <div className="title-detail-order">
                                                                Tóm tắt đơn hàng
                                                            </div>
                                                            <div className="order-summary">
                                                                {
                                                                    this.state.isLoadingDetail ? (
                                                                        <div className="text-center">
                                                                            <Spinner animation="grow" variant="primary" />
                                                                            <Spinner animation="grow" variant="secondary" />
                                                                            <Spinner animation="grow" variant="success" />
                                                                            <Spinner animation="grow" variant="danger" />
                                                                            <Spinner animation="grow" variant="warning" />
                                                                            <Spinner animation="grow" variant="info" />
                                                                        </div>
                                                                    ) : (
                                                                        <>
                                                                            {
                                                                                this.state.isDetailOrder ? (
                                                                                    <>
                                                                                        {
                                                                                            this.state.errorDetail ? (
                                                                                                <Alert color="danger">
                                                                                                    { this.state.messageDetail }
                                                                                                </Alert>
                                                                                            ) : (
                                                                                                <>
                                                                                                    <div className="order-summary-product">
                                                                                                        <div className="item">
                                                                                                            {
                                                                                                                this.state.typeOrder === 'addon_vps' || this.state.typeOrder === 'addon_cloud_server' ||
                                                                                                                this.state.typeOrder === 'upgrade' || this.state.typeOrder === 'expire_vps'
                                                                                                                || this.state.typeOrder === 'expire_vps_us'
                                                                                                                || this.state.typeOrder === 'expire_cloud_server'
                                                                                                                || this.state.typeOrder === 'expire_hosting_cpanel' ? (
                                                                                                                    <div className="itemtitle text-center">
                                                                                                                        { this.state.contentDetailOrder.nameProduct }
                                                                                                                    </div>
                                                                                                                ) : (
                                                                                                                   <>
                                                                                                                       <div className="itemtitle">
                                                                                                                           { this.state.contentDetailOrder.nameProduct }
                                                                                                                       </div>
                                                                                                                       <div className="row">
                                                                                                                           <div className="col col-md-6 item_billing">
                                                                                                                               { this.state.contentDetailOrder.billingCycle }
                                                                                                                           </div>
                                                                                                                           <div className="col col-md-6 item_pricing text-right">
                                                                                                                               { this.state.contentDetailOrder.pricingProduct } ₫
                                                                                                                           </div>
                                                                                                                       </div>
                                                                                                                   </>
                                                                                                                )
                                                                                                            }
                                                                                                        </div>
                                                                                                    </div>
                                                                                                    <div className="addon-item-cpu">
                                                                                                        {
                                                                                                            this.state.contentDetailOrder.addonCpu.error === 0 ? (
                                                                                                                <div className="item">
                                                                                                                    <div className="itemtitle">
                                                                                                                        { this.state.contentDetailOrder.addonCpu.name }
                                                                                                                    </div>
                                                                                                                    <div className="row">
                                                                                                                        <div className="col col-md-6 item_billing">
                                                                                                                            {
                                                                                                                                <>
                                                                                                                                    {
                                                                                                                                        this.state.typeOrder === 'upgrade' ? (
                                                                                                                                            <>
                                                                                                                                                { this.state.contentDetailOrder.addonCpu.qtt  }
                                                                                                                                            </>
                                                                                                                                        ) : (
                                                                                                                                            <>
                                                                                                                                                { this.state.contentDetailOrder.addonCpu.qtt  } Cores
                                                                                                                                            </>
                                                                                                                                        )
                                                                                                                                    }
                                                                                                                                </>

                                                                                                                            }
                                                                                                                        </div>
                                                                                                                        <div className="col col-md-6 item_pricing text-right">
                                                                                                                            { this.state.contentDetailOrder.addonCpu.amount } ₫
                                                                                                                        </div>
                                                                                                                    </div>
                                                                                                                </div>
                                                                                                            ) : (
                                                                                                                <></>
                                                                                                            )
                                                                                                        }
                                                                                                    </div>
                                                                                                    <div className="addon-item-ram">
                                                                                                        {
                                                                                                            this.state.contentDetailOrder.addonRam.error === 0 ? (
                                                                                                                <div className="item">
                                                                                                                    <div className="itemtitle">
                                                                                                                        { this.state.contentDetailOrder.addonRam.name }
                                                                                                                    </div>
                                                                                                                    <div className="row">
                                                                                                                        <div className="col col-md-6 item_billing">
                                                                                                                            { this.state.contentDetailOrder.addonRam.qtt } Cores
                                                                                                                        </div>
                                                                                                                        <div className="col col-md-6 item_pricing text-right">
                                                                                                                            { this.state.contentDetailOrder.addonRam.amount } ₫
                                                                                                                        </div>
                                                                                                                    </div>
                                                                                                                </div>
                                                                                                            ) : (
                                                                                                                <></>
                                                                                                            )
                                                                                                        }
                                                                                                    </div>
                                                                                                    <div className="addon-item-disk">
                                                                                                        {
                                                                                                            this.state.contentDetailOrder.addonDisk.error === 0 ? (
                                                                                                                <div className="item">
                                                                                                                    <div className="itemtitle">
                                                                                                                        { this.state.contentDetailOrder.addonDisk.name }
                                                                                                                    </div>
                                                                                                                    <div className="row">
                                                                                                                        <div className="col col-md-6 item_billing">
                                                                                                                            { this.state.contentDetailOrder.addonDisk.qtt } GB
                                                                                                                        </div>
                                                                                                                        <div className="col col-md-6 item_pricing text-right">
                                                                                                                            { this.state.contentDetailOrder.addonDisk.amount } ₫
                                                                                                                        </div>
                                                                                                                    </div>
                                                                                                                </div>
                                                                                                            ) : (
                                                                                                                <></>
                                                                                                            )
                                                                                                        }
                                                                                                    </div>
                                                                                                    <div className="order-summary-subtotal">
                                                                                                        <div className="row">
                                                                                                            <div className="col-md-3">Tổng</div>
                                                                                                            <div className="col-md-9 text-right">{ this.state.contentDetailOrder.subTotal } ₫</div>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                    <div className="order-summary-qtt">
                                                                                                        <div className="row">
                                                                                                            <div className="col-md-3">Số lượng</div>
                                                                                                            <div className="col-md-9 text-right">{ this.state.contentDetailOrder.qtt }</div>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                    <div className="order-summary-total">
                                                                                                        <div className="row">
                                                                                                            <div className="col-md-4">Tổng cộng</div>
                                                                                                            <div className="col-md-8 text-right">{ this.state.contentDetailOrder.total } ₫</div>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                </>
                                                                                            )
                                                                                        }
                                                                                    </>
                                                                                ) : (
                                                                                    <>
                                                                                        <div className="order-summary-product">
                                                                                            <div className="text-none">
                                                                                                Chưa có sản phẩm / dịch vụ được chọn
                                                                                            </div>
                                                                                        </div>
                                                                                    </>
                                                                                )

                                                                            }
                                                                        </>
                                                                    )
                                                                }
                                                            </div>
                                                            <div className="button_submit text-center">
                                                                <button className="btn btn-primary btn-block"
                                                                        onClick={ () => this.submit() }
                                                                        disabled={this.state.btnSubmit}
                                                                >
                                                                    Tạo đơn hàng
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </CardBody>
                                        </Card>
                                    </>
                                )
                            }
                        </>
                    )
                }
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.login.token,
        isNotification: state.adminMain.isNotification,
        textNotification: state.adminMain.textNotification,
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        logOut: () => {
            dispatch(({ type : 'logOut', page: 'AdminCreateOrder' }))
        },
        notification: (item) => {
            dispatch(({ type : 'notification', item }))
        },
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(CreateOrderComponent);